export const CMS_LINKS_FETCH_INTERVAL = 1000 * 60 * 60 * 1; // 1 hour
export const AUTHORIZED_PAGE_SLUG = 'users-footer';
export const UNAUTHORIZED_PAGE_SLUG = 'footer';
export const FOOTER_ERROR = 'Error loading footer';
